<template>
  <div class="carousel" v-loading="loading">
    <back />
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="ruleForm" label-position="left">
      <div class="title">活动信息：</div>
      <el-row>
        <el-col>
          <el-form-item label="图片" prop="activityPicture">
            <el-upload class="pic_uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="action"
              :show-file-list="false" :on-success="uploadSuccess('ruleForm', 'activityPicture')"
              :before-upload="beforeUploads" :on-remove="() => onRemove('ruleForm', 'activityPicture')"
              :disabled="ruleForm.activityPicture ? true : false">
              <el-image class="picurl" v-if="ruleForm.activityPicture" :src="ruleForm.activityPicture"
                :preview-src-list="[ruleForm.activityPicture]">
              </el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <i v-if="ruleForm.activityPicture" class="delpic_uploader el-icon-error"
              @click="() => onRemove('ruleForm', 'activityPicture')"></i>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between">
        <el-col :span="7">
          <el-form-item label="活动名称：" prop="activityName" label-width="120px">
            <el-input style="width: 250px;" v-model.trim="ruleForm.activityName" placeholder="请输入活动名称"
              clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="活动类型：" prop="activityType" label-width="120px">
            <el-select style="width: 250px;" v-model="ruleForm.activityType" placeholder="请选择活动类型" clearable
              :disabled="this.$route.query.activityType !== undefined">
              <el-option v-for="item in activityTypeArr" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="活动分类：" prop="categoryId" label-width="120px">
            <el-select style="width: 250px;" v-model="ruleForm.categoryId" placeholder="请选择活动分类" clearable>
              <el-option v-for="item in categoryIdArr" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between"
        v-if="ruleForm.activityType !== '' && (ruleForm.activityType == 1 || this.$route.query.activityType == 1)">
        <el-col :span="7">
          <el-form-item label="报名开始时间：" prop="signUpStartTime">
            <el-date-picker style="width: 250px;" v-model="ruleForm.signUpStartTime" type="datetime"
              placeholder="选择日期时间" default-time="12:00:00" value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions" @change="handleDatePickerChange"
              :disabled="this.$route.query.activityType !== undefined">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="报名截止时间：" prop="signUpEndTime">
            <el-date-picker style="width: 250px;" v-model="ruleForm.signUpEndTime" type="datetime"
              placeholder="请先选择报名开始时间" default-time="12:00:00" value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions" :disabled="!!this.$route.query.activityType || !ruleForm.signUpStartTime">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="7"></el-col>
      </el-row>
      <el-row
        v-if="ruleForm.activityType !== '' && (ruleForm.activityType == 1 || this.$route.query.activityType == 1)">
        <el-col>
          <el-form-item label="二维码图片" prop="groupPicture">
            <el-upload class="pic_uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="action"
              :show-file-list="false" :on-success="uploadSuccess1('ruleForm', 'groupPicture')"
              :before-upload="beforeUploads" :on-remove="() => onRemove1('ruleForm', 'groupPicture')"
              :disabled="ruleForm.groupPicture ? true : false">
              <el-image class="picurl" v-if="ruleForm.groupPicture" :src="ruleForm.groupPicture"
                :preview-src-list="[ruleForm.groupPicture]">
              </el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <i v-if="ruleForm.groupPicture" class="delpic_uploader2 el-icon-error"
              @click="() => onRemove1('ruleForm', 'groupPicture')"></i>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between"
        v-if="ruleForm.activityType !== '' && (ruleForm.activityType == 0 || this.$route.query.activityType == 0)">
        <el-col :span="7">
          <el-form-item label="报名开始时间：" prop="signUpStartTime">
            <el-date-picker style="width: 250px;" v-model="ruleForm.signUpStartTime" type="datetime"
              placeholder="选择日期时间" default-time="12:00:00" value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions" @change="handleDatePickerChange"
              :disabled="this.$route.query.activityType !== undefined">
            </el-date-picker>
            <!-- <el-date-picker v-model="ruleForm.signUpStartTime" type="datetime" default-time="12:00"
              format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="选择日期时间" style="width: 250px;"
              :picker-options="pickerOptions">
            </el-date-picker> -->
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="报名截止时间：" prop="signUpEndTime">
            <el-date-picker style="width: 250px;" v-model="ruleForm.signUpEndTime" type="datetime"
              placeholder="请先选择报名开始时间" default-time="12:00:00" value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
              :disabled="this.$route.query.activityType !== undefined || !ruleForm.signUpStartTime">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="投票开始时间：" prop="voteStartTime">
            <el-date-picker style="width: 250px;" v-model="ruleForm.voteStartTime" type="datetime"
              placeholder="请先选择报名截止时间" default-time="12:00:00" value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
              :disabled="this.$route.query.activityType !== undefined || !ruleForm.signUpEndTime">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between"
        v-if="ruleForm.activityType !== '' && (ruleForm.activityType == 0 || this.$route.query.activityType == 0)">
        <el-col :span="7">
          <el-form-item label="投票截止时间：" prop="voteEndTime">
            <el-date-picker style="width: 250px;" v-model="ruleForm.voteEndTime" type="datetime"
              placeholder="请先选择投票开始时间" default-time="12:00:00" value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
              :disabled="this.$route.query.activityType !== undefined || !ruleForm.voteStartTime">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="投票次数：" prop="voteCount" label-width="120px">
            <el-select style="width: 120px;" v-model="ruleForm.voteType" clearable
              :disabled="this.$route.query.activityType !== undefined">
              <el-option v-for="item in voteTypeArr" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-input style="width: 120px;margin:0 8px;" v-model.number="ruleForm.voteCount" placeholder="请输入" clearable
              :disabled="this.$route.query.activityType !== undefined"></el-input><span style="color: #606266;">次</span>
          </el-form-item>
        </el-col>
        <el-col :span="7"></el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-form-item class="" label="活动介绍：" label-width="120px">
            <editor ref="editor" :htmls="ruleForm.introduce" @change="onChangeEditor" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="btn">
      <el-button type="primary" @click="submitForm('ruleForm')" :loading="btnLoading" plain>确 定</el-button>
    </div>
  </div>
</template>

<script>
import editor from "@/components/editor.vue"
export default {
  components: {
    editor
  },
  data() {
    // 自定义验证器：检查 报名截止时间 是否大于 报名开始时间
    const validateTime2 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请选择日期时间'));
      }
      // 比较两个时间
      if (new Date(value) <= new Date(this.ruleForm.signUpStartTime)) {
        callback(new Error('报名截止时间必须晚于报名开始时间'));
      } else {
        callback();
      }
    };

    // 自定义验证器：检查 投票截止时间 是否大于 投票开始时间
    const validateTime4 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请选择日期时间'));
      }
      // 比较两个时间
      if (new Date(value) <= new Date(this.ruleForm.voteStartTime)) {
        callback(new Error('投票截止时间必须晚于投票开始时间'));
      } else if (new Date(value) < new Date(this.ruleForm.signUpEndTime)) {
        callback(new Error('投票截止时间必须晚于或等于报名截止时间'));
      } else {
        callback();
      }
    };
    // 自定义验证器：检查 投票开始时间 是否大于等于 报名开始时间
    const validateTime3 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请选择日期时间'));
      }
      // 比较两个时间
      if (new Date(value) < new Date(this.ruleForm.signUpStartTime)) {
        callback(new Error('投票开始时间必须晚于或等于报名开始时间'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      btnLoading: false,
      voteTypeArr: [
        {
          value: '0',
          label: '总共'
        }, {
          value: '1',
          label: '每天'
        },
      ],//投票类型
      activityTypeArr: [
        {
          value: '0',
          label: '投票活动'
        }, {
          value: '1',
          label: '进群活动'
        },
      ],//活动类型
      categoryIdArr: [],//活动分类
      ruleForm: {
        id: null,//
        activityType: '',//活动类型
        activityName: "",//标题
        signUpStartTime: "",//报名开始时间
        signUpEndTime: "",//报名截止时间
        voteStartTime: "",//投票开始时间
        voteEndTime: "",//投票截止时间
        categoryId: "",//活动分类
        activityPicture: "",//图片链接
        groupPicture: "",//二维码图片链接
        voteType: "0",//投票类型
        voteCount: "",//投票次数
        introduce: "",//活动介绍
      },
      rules: {
        activityName: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        activityType: [{ required: true, message: "请选择活动类型", trigger: "blur" }],
        categoryId: [{ required: true, message: "请选择活动分类", trigger: "blur" }],
        signUpStartTime: [{ required: true, message: "请选择日期时间", trigger: "blur" }],
        signUpEndTime: [{ required: true, message: "请选择日期时间", trigger: "blur" }, { validator: validateTime2, trigger: "blur" }],
        voteStartTime: [{ required: true, message: "请选择日期时间", trigger: "blur" }, { validator: validateTime3, trigger: "blur" }],
        voteEndTime: [{ required: true, message: "请选择日期时间", trigger: "blur" }, { validator: validateTime4, trigger: "blur" }],
        activityPicture: [{ required: true, message: "请上传图片", trigger: "blur" }],
        groupPicture: [{ required: true, message: "请上传二维码图片", trigger: "blur" }],
        voteCount: [{ required: true, message: "请输入投票次数", trigger: "change" }, {
          type: "number", // 限制为数字类型
          pattern: /^[1-9]\d*$/, // 正整数正则表达式
          message: "请输入数字",
          trigger: "change"
        }],
      },
      pickerOptions: {
        disabledDate(time) {
          // 禁用今天之前的日期
          return time.getTime() < new Date(new Date().toDateString()).getTime();
        }
      },
      action: this.$axios.defaults.baseURL + this.$api.uploadFile,
    }
  },
  // 路由进入前守卫：在进入路由前动态设置页面标题
  beforeRouteEnter(to, from, next) {
    // 根据路由参数判断是编辑还是新增活动
    if (to.query.id) {
      to.meta.title = "编辑活动";
    } else {
      to.meta.title = "新增活动";
    }
    next();// 继续路由导航
  },
  // 组件挂载后设置页面标题
  mounted() {
    document.title = this.$route.meta.title;
    if (this.$route.query.id) this.getRequestList()
  },
  // 监听路由变化，动态更新页面标题
  watch: {
    '$route'(to, from) {
      document.title = to.meta.title;
    },
  },
  created() {
    this.getRequestActivityClassList()
    console.log(this.$route.query.activityType);

  },
  methods: {
    // 详情请求（编辑）
    getRequestList() {
      this.loading = true
      this.$axios
        .get(this.$api.editActivityDetail, {
          params: {
            id: this.$route.query.id,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.loading = false
            this.ruleForm = res.result
            // 回显 voteType 字段
            const voteTypeItem = this.voteTypeArr.find(item => item.value == res.result.voteType);
            this.ruleForm.voteType = voteTypeItem ? voteTypeItem.label : '';
            // 回显 activityType 字段
            const activityTypeItem = this.activityTypeArr.find(item => item.value == res.result.activityType);
            this.ruleForm.activityType = activityTypeItem ? activityTypeItem.label : '';
            this.fillEditorContent(res.result.introduce);
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    // 活动分类下拉框
    getRequestActivityClassList() {
      this.loading = true
      this.$axios
        .get(this.$api.activityListActivityClass)
        .then(res => {
          if (res.code == 100) {
            this.categoryIdArr = res.result.map((item) => {
              return {
                value: item.id,
                label: item.categoryName
              }
            })
            this.loading = false
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    // 报名开始时间清空控制
    handleDatePickerChange(value) {
      if (value == null) {
        this.$set(this.ruleForm, 'signUpStartTime', '')
        this.$set(this.ruleForm, 'signUpEndTime', '')
        this.$set(this.ruleForm, 'voteStartTime', '')
        this.$set(this.ruleForm, 'voteEndTime', '')
      }
    },
    // 编辑器内容
    onChangeEditor(value) {
      this.ruleForm.introduce = value
    },
    // 编辑器安全回填内容（确保编辑器已渲染）
    fillEditorContent(htmlContent) {
      if (this.$refs.editor) {
        // 编辑器已就绪，直接回填
        this.ruleForm.introduce = htmlContent;
        // console.log('第一次回填');

      } else {
        // 编辑器未就绪，等待下一个DOM更新周期
        this.$nextTick(() => {
          // console.log('第二次回填');
          this.fillEditorContent(htmlContent);
        });
      }
    },
    // 文件上传前
    beforeUploads(file) {
      const isJPG = file.type === "image/jpeg" || "image/jpg" || "image/png"
      // const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!")
      }
      // if (!isLt5M) {
      //   this.$message.error("上传图片大小不能超过 5MB!")
      // }
      // return isJPG && isLt5M
      return isJPG
    },
    // 删除图片
    onRemove(form, str) {
      this.$set(this[form], str, "")
    },
    // 上传成功
    uploadSuccess(form, str) {
      return (response,) => {
        if (response.code == 100) {
          this.$set(this[form], str, response.result.fileUrl)
        } else {
          this.$message.error(response.desc)
        }
      }
    },
    // 文件上传前
    beforeUploads1(file) {
      const isJPG = file.type === "image/jpeg" || "image/jpg" || "image/png"
      // const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!")
      }
      // if (!isLt5M) {
      //   this.$message.error("上传图片大小不能超过 5MB!")
      // }
      // return isJPG && isLt5M
      return isJPG
    },
    // 删除图片
    onRemove1(form, str) {
      this.$set(this[form], str, "")
    },
    // 上传成功
    uploadSuccess1(form, str) {
      return (response,) => {
        if (response.code == 100) {
          this.$set(this[form], str, response.result.fileUrl)
        } else {
          this.$message.error(response.desc)
        }
      }
    },

    // 提交数据
    submitForm() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.btnLoading = true
          let api;
          let obj = Object.assign({}, this.ruleForm)
          obj.voteType = obj.voteType == '总共' ? 0 : obj.voteType == '每天' ? 1 : obj.voteType
          obj.activityType = obj.activityType == '投票活动' ? 0 : obj.activityType == '进群活动' ? 1 : obj.activityType
          // obj.voteType = String(obj.voteType)
          if (this.$route.query.id) {
            api = this.$api.editActivity
          } else {
            api = this.$api.addActivity
          }
          this.$axios
            .post(api, obj)
            .then(res => {
              if (res.code == 100) {
                this.btnLoading = false
                this.$message.success(`${this.$route.query.id ? "修改" : "新增"}成功`)
                this.$router.go(-1)
              }
            })
            .catch(err => {
              this.btnLoading = false
              this.$message.error(err.desc)
            })
        }
      })
    },
  },
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped lang="scss">
.carousel {
  ::v-deep .el-radio__original {
    display: none !important;

  }

  ::v-deep .el-input-number__decrease {
    border-radius: 10px 0 0 10px;
  }

  ::v-deep .el-input-number__increase {
    border-radius: 0 10px 10px 0;
  }

  .title {
    font-size: 18px;
    //margin-left: 60px;
    padding-bottom: 15px;
    padding-left: 20px;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }

  .show_img {
    color: $themes;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }

  .pic_uploader {
    ::v-deep .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    ::v-deep .el-upload:hover {
      border-color: $themes;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: $themes;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }

    ::v-deep .el-upload--picture-card {
      background-color: #fff;
    }

    ::v-deep .el-upload-list__item-thumbnail {
      object-fit: cover;
    }

    .picurl {
      width: 100px;
      height: 100px;
      display: block;
      object-fit: cover;
    }
  }

  .delpic_uploader {
    position: absolute;
    top: -10px;
    left: 140px;
    color: red;
    font-size: 20px;
    cursor: pointer;
  }

  .delpic_uploader2 {
    position: absolute;
    top: -10px;
    left: 180px;
    color: red;
    font-size: 20px;
    cursor: pointer;
  }
}
</style>
